[
  {
    "id": "SR-E7P-KOPIEREN-V01",
    "module": "SpellingRegel",
    "difficulty": 206,
    "difficultyTier": 12,
    "levelCode": "E7+",
    "group": 7,
    "skill": "schrijfwijze",
    "subSkill": "trema",
    "familyId": "SR-TREMA-WERKWOORD",
    "conceptId": "trema_in_verb_conjugation",
    "variantIndex": 1,
    "questionType": "multiple_choice",
    "question": "Kies het juiste woord: ...",
    "options": ["kopiëren", "kopieren", "kopiëeren", "kopieeren"],
    "correctAnswer": 0,
    "explanation": "'Kopiëren' heeft een trema op de 'e'. Dit voorkomt dat je 'kopie-ren' verkeerd leest. Het trema laat zien: kopi-ë-ren.",
    "distractorExplanations": {
      "1": "Trema vergeten. Zonder trema is de uitspraak onduidelijk.",
      "2": "Te veel e's. Het is kopiëren, niet kopiëeren.",
      "3": "Trema vergeten én te veel e's."
    }
  },
  {
    "id": "SR-E7P-FINANCIELE-V01",
    "module": "SpellingRegel",
    "difficulty": 206,
    "difficultyTier": 12,
    "levelCode": "E7+",
    "group": 7,
    "skill": "schrijfwijze",
    "subSkill": "trema",
    "familyId": "SR-TREMA-BIJVOEGLIJK",
    "conceptId": "trema_in_adjective",
    "variantIndex": 1,
    "questionType": "multiple_choice",
    "question": "Welk woord is goed geschreven?",
    "options": ["financiële", "financiele", "financieele", "financiëele"],
    "correctAnswer": 0,
    "explanation": "'Financiële' heeft een trema op de 'e'. Dit laat zien dat de 'e' apart uitgesproken wordt: financi-ë-le.",
    "distractorExplanations": {
      "1": "Trema vergeten. Zonder trema zou je 'financiele' als drie lettergrepen lezen.",
      "2": "Te veel e's. Het is financiële, niet financieele.",
      "3": "Te veel e's na het trema. Het is financiële."
    }
  },
  {
    "id": "SR-E7P-PANNENKOEK-V01",
    "module": "SpellingRegel",
    "difficulty": 206,
    "difficultyTier": 12,
    "levelCode": "E7+",
    "group": 7,
    "skill": "schrijfwijze",
    "subSkill": "tussen_n_s",
    "familyId": "SR-TUSSEN-N",
    "conceptId": "compound_linking_n",
    "variantIndex": 2,
    "questionType": "multiple_choice",
    "question": "Kies het juiste woord: ...",
    "options": ["pannenkoek", "pannekoek", "pannen-koek", "panne-koek"],
    "correctAnswer": 0,
    "explanation": "'Pan' heeft een meervoud op '-en' (pannen). Dus pannenkoek met tussen-n. Samenstellingen schrijf je aan elkaar, zonder streepje.",
    "distractorExplanations": {
      "1": "Tussen-n vergeten. Het meervoud van pan is pannen, dus de 'n' hoort erbij.",
      "2": "Geen streepje. Samenstellingen schrijf je aan elkaar.",
      "3": "Geen streepje, en de tussen-n ontbreekt."
    }
  },
  {
    "id": "SR-E7P-ZONNEBRIL-V01",
    "module": "SpellingRegel",
    "difficulty": 206,
    "difficultyTier": 12,
    "levelCode": "E7+",
    "group": 7,
    "skill": "schrijfwijze",
    "subSkill": "tussen_n_s",
    "familyId": "SR-GEEN-TUSSEN-N",
    "conceptId": "compound_no_linking_n",
    "variantIndex": 1,
    "questionType": "multiple_choice",
    "question": "Welk woord is goed geschreven?",
    "options": ["zonnebril", "zonnenbril", "zon-bril", "zonebril"],
    "correctAnswer": 0,
    "explanation": "Er is maar één zon, dus geen tussen-n. Het is 'zonne-' (verbindingsklank) + 'bril' = zonnebril. Vergelijk: zonneschijn, zonnebloem.",
    "distractorExplanations": {
      "1": "Geen tussen-n. Er is maar één zon, dus het is 'zonne-', niet 'zonnen-'.",
      "2": "Geen streepje. Samenstellingen schrijf je aan elkaar.",
      "3": "De dubbele 'n' hoort bij de korte klank: zon-ne-bril."
    }
  },
  {
    "id": "SR-E7P-MIDDELEEUWEN-V01",
    "module": "SpellingRegel",
    "difficulty": 206,
    "difficultyTier": 12,
    "levelCode": "E7+",
    "group": 7,
    "skill": "schrijfwijze",
    "subSkill": "samenstelling",
    "familyId": "SR-SAMENSTELLING-LANG",
    "conceptId": "long_compound_word",
    "variantIndex": 1,
    "questionType": "multiple_choice",
    "question": "Kies het juiste woord: ...",
    "options": ["middeleeuwen", "middeleeuwn", "middel-eeuwen", "middeleeuwe"],
    "correctAnswer": 0,
    "explanation": "'Middeleeuwen' is een samenstelling: middel + eeuwen. Eén 'l', dubbele 'e'. Aan elkaar geschreven.",
    "distractorExplanations": {
      "1": "De 'e' aan het eind ontbreekt. Het is 'eeuwen', niet 'eeuwn'.",
      "2": "Geen streepje. Samenstellingen schrijf je aan elkaar.",
      "3": "De 'n' aan het eind ontbreekt. Het is 'eeuwen', niet 'eeuwe'."
    }
  }
]